import * as tslib_1 from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
let Address = class Address extends Vue {
    constructor() {
        super(...arguments);
        this.loading = true;
        this.receiver = {};
    }
    get address() {
        return `${this.receiver.province_name}${this.receiver.city_name}${this
            .receiver.district_name || ''}${this.receiver.address}`;
    }
    created() {
        this.loading = true;
        this.showAddress();
    }
    async toAddressList() {
        // 电商埋点-确认订单页点击新建/编辑地址
        await this.uploadEvent.sendRecord(this.receiver.id
            ? 'Click_ConfirmOrder_EditAddress'
            : 'Click_ConfirmOrder_AddAddress', '', this.products.reduce((t, c, i) => {
            t.SkuID = t.SkuID += i === 0 ? `${c.id}` : `_${c.id}`;
            t.GoodsName = t.GoodsName += i === 0 ? `${c.title}` : `_${c.title}`;
            return t;
        }, {
            GoodsName: '',
            SkuID: '',
        }), [['p1', 'SkuID']]);
        let { pt = 'wechat', type, spuId, skuId, from, application, startTime, invitation, channel_activity, gift_activity, channel_id, invitationId, isGroup, group_order_id, ticket, balance, activity_id, cid, goodType, receiver_id, isCart, confirmId, scholarship_distribution_id, scholarship_distributor_id, sign, } = this.$route.query;
        if (from === 'final')
            return; // 预售付尾款不允许修改地址
        let _head = location.origin;
        if (_head.indexOf('localhost') > -1) {
            _head = 'http://m.ivydad.com.cn';
        }
        // 如果是购物车订单
        if (isCart === 'true') {
            let redirect = `${window.location.origin}${window.location.pathname}?isCart=true&confirmId=${confirmId}`;
            window.location.replace(`${location.origin}/center/address/addressList?mode=select${receiver_id ? '&receiverId=' + receiver_id : ''}&redirect=` + encodeURIComponent(redirect));
            return;
        }
        let _redirect = `${window.location.origin}${window.location.pathname}?pt=${pt}&spuId=${spuId}&skuId=${skuId}&type=${type}&application=${application}&startTime=${startTime}`;
        scholarship_distribution_id &&
            (_redirect += `&scholarship_distribution_id=${scholarship_distribution_id}`);
        scholarship_distributor_id &&
            (_redirect += `&scholarship_distributor_id=${scholarship_distributor_id}`);
        invitation && (_redirect += `&invitation=gold`);
        invitationId && (_redirect += `&invitationId=${invitationId}`);
        isGroup && (_redirect += `&isGroup=${isGroup}`);
        from === 'ticket' &&
            (_redirect += `&from=ticket&ticket=${ticket}&balance=${balance}&activity_id=${activity_id}`);
        group_order_id && (_redirect += `&group_order_id=${group_order_id}`);
        channel_activity && (_redirect += `&channel_activity=${channel_activity}`);
        gift_activity && (_redirect += `&gift_activity=${gift_activity}`);
        channel_id && (_redirect += `&channel_id=${channel_id}`);
        goodType && (_redirect += `&goodType=${goodType}`);
        cid && (_redirect += `&cid=${cid}`);
        sign && (_redirect += `&sign=${sign}`);
        window.location.replace(`${_head}/center/address/addressList?mode=select${receiver_id ? '&receiverId=' + receiver_id : ''}&redirect=` + encodeURIComponent(_redirect));
    }
    async showAddress() {
        let { receiver_id } = this.$route.query;
        let { data } = await this.$axios.post(`/api/mobile/course/yaya/getUserReceiver`);
        this.loading = false;
        let checkAddress = data.find(item => {
            if (receiver_id) {
                return item.id === +receiver_id;
            }
            else {
                return item.is_default;
            }
        }) || {};
        // receiver就是接收的传回来的地址
        this.receiver = checkAddress;
        this.$emit('update:receiverChange', checkAddress);
    }
};
tslib_1.__decorate([
    Prop()
], Address.prototype, "needReceiver", void 0);
tslib_1.__decorate([
    Prop()
], Address.prototype, "uploadEvent", void 0);
tslib_1.__decorate([
    Prop()
], Address.prototype, "products", void 0);
Address = tslib_1.__decorate([
    Component
], Address);
export default Address;
